const FALLBACK_TOKEN_IMAGE = "/unknown.svg";

/** Resolves local public paths and remote token icon URLs for img src. */
export function normalizeTokenImageUrl(image: string | undefined | null): string {
  if (!image) return FALLBACK_TOKEN_IMAGE;
  if (
    image.startsWith("http://") ||
    image.startsWith("https://") ||
    image.startsWith("data:")
  ) {
    return image;
  }
  if (image.startsWith("/")) return image;
  return `/${image}`;
}
